import * as React from "react";
import { Table, TableProps } from "@mantine/core";

interface ITableDataProps {
  data: React.ReactNode[][];
  striped?: boolean;
}

export const SSTable: React.FC<TableProps> = (props) => {
  return <Table striped={props.striped ?? true} {...props} />
}

export const TableData: React.FunctionComponent<ITableDataProps> = ({ data }) => (
  <SSTable cellPadding="5px">
    <tbody>
      {data.map((val, idx) => (
        <tr key={idx}>
          {val.map((v, idx2) => (
            <td key={`dt-${idx}-${idx2}`}>{v}</td>
          ))}
        </tr>
      ))}
    </tbody>
  </SSTable>
);



